<template>
  <div v-loading="loadingStatus"
       element-loading-text="数据加载中……"
       element-loading-spinner="el-icon-loading">
    <div v-if="year">
      <!--      -->
      <el-table :data="tableData" class="dashboard-table" :span-method="objectSpanMethod" border show-summary
                :summary-method="getSummaries"
                :header-row-style="{backgroundColor:'#fff'}">
        <el-table-column prop="x" :label="`${year}年`" width="65">
          <template slot-scope="scope">
            {{ scope.row.x }}月
          </template>
        </el-table-column>
        <el-table-column prop="order_count" label="订单数（单）" align="right"/>
        <el-table-column prop="order_money" label="订单金额（元）" align="right">
          <template slot-scope="scope">
            <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_exec_count" label="其中已执行（单）" align="right"/>
        <el-table-column prop="order_exec_money" label="其中已执行（金额）" align="right">
          <template slot-scope="scope">
            <span class="money">{{ gFunc.numberFormat(scope.row.order_exec_money) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_back_money" label="其中已回款（金额）" align="right">
          <template slot-scope="scope">
            <span class="money">{{ gFunc.numberFormat(scope.row.order_back_money) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remainder_order_back_money" label="其中未回款（金额）" align="right">
          <template slot-scope="scope">
            <span class="money">{{ gFunc.numberFormat(scope.row.remainder_order_back_money) }}</span>
          </template>
        </el-table-column>
        <template v-if="showQuarter">
          <el-table-column prop="quarter_num" label="季度" width="80" align="center">
            <template slot-scope="{row}">
              <span>第 {{ row.quarter_num }} 季度</span>
            </template>

          </el-table-column>
          <!--          <el-table-column prop="quarter" label="季度" width="60" align="center"/>-->
          <el-table-column prop="quarter_order_count" label="订单数（单）" align="right"/>
          <el-table-column prop="quarter_order_money" label="订单金额（元）" align="right">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.quarter_order_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarter_order_exec_count" label="其中已执行（单）" align="right"/>
          <el-table-column prop="quarter_order_exec_money" label="其中已执行（金额）" align="right">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.quarter_order_exec_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarter_order_back_money" label="其中已回款（金额）" align="right">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.quarter_order_back_money) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarter_remainder_order_back_money" label="其中未回款（金额）" align="right">
            <template slot-scope="scope">
              <span class="money">{{ gFunc.numberFormat(scope.row.quarter_remainder_order_back_money) }}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

  </div>
</template>

<script>
import {getSummaryMonthly} from "@/api/dashboard";

export default {
  name: "SummaryYearTable",
  props: {
    organizationId: [Number, String, Boolean],
    year: {
      type: [Number, String],
      default() {
        return null
      }
    },
    switchShowQuarter: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      tableData: [],
      loadingStatus: false,
      switchCompareMonth: false,
      showQuarter: false,
    }
  },
  watch: {
    switchShowQuarter(val) {
      this.showQuarter = val
    }
  },
  methods: {
    // 合并单元格
    // eslint-disable-next-line
    objectSpanMethod({rowIndex, columnIndex}) {
      if ([7, 8, 9, 10, 11, 12, 13].includes(columnIndex)) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getTableData() {

      this.tableData = [];
      if (this.year) {
        this.loadingStatus = true
        getSummaryMonthly({year: this.year, organization_id: this.organizationId}).then(res => {
          this.loadingStatus = false
          let data = res.model || [];
          // 未回款金额（remainder_order_back_money）与季度聚合（quarter_*）已由后端
          // DataDashboardHandler::summaryMonthly() 计算返回，前端仅展示
          this.tableData = data;
        });
      }
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_count', 'order_exec_money', 'order_exec_count', 'quarter_order_count',
          'quarter_order_exec_count', 'quarter_order_money', 'quarter_order_exec_money', 'quarter_order_back_money',
          'order_back_money', 'remainder_order_back_money', 'quarter_remainder_order_back_money'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
            case "order_exec_money":
            case "quarter_order_money":
            case "quarter_order_exec_money":
            case "order_back_money":
            case "remainder_order_back_money":
            case "quarter_order_back_money":
            case "quarter_remainder_order_back_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_count":
            case "order_exec_count":
            case "quarter_order_count":
            case "quarter_order_exec_count":
              sums[index] = this.gFunc.numberFormat(sums[index]);
              break;
          }
        }
      });
      return sums
    },

  },
  created() {
    this.getTableData()
  }
}
</script>

<style scoped>
</style>
